<script setup lang="ts">
import { useMemory } from '@vueuse/core';
import { MMText } from '@mm-frontend/mm-web-ui-kit';

const { memory, isSupported } = useMemory();

function size(v: number) {
  const kb = v / 1024 / 1024;
  return `${kb.toFixed(2)} MB`;
}
</script>

<template>
  <div class="memory-usage">
    <MMText font="Caption S/Regular" color="secondary" v-if="isSupported && memory">
      <div>Используется</div>
      <div>{{ size(memory.usedJSHeapSize) }}</div>
      <div>Выделено</div>
      <div>{{ size(memory.totalJSHeapSize) }}</div>
      <div>Ограничение</div>
      <div>{{ size(memory.jsHeapSizeLimit) }}</div>
    </MMText>

    <MMText font="Caption S/Regular" color="secondary" v-else>
      <div>MemoryUsage<br />не поддерживается</div>
    </MMText>
  </div>
</template>

<style scoped lang="stylus">
.memory-usage
  padding 4px 8px
  border-radius 4px
  background-color var(--background-primary)
  border 1px solid var(--border-subtle)
</style>
